<script setup lang="ts">
import UseSvg from "common/vue/components/UseSvg.vue";

defineProps<{
  active: boolean;
  icon?: string | undefined;
  onClick: () => void;
}>();
</script>

<template>
  <button
    type="button"
    class="tab-button"
    :class="{
      'tab-button--active': active
    }"
    @click.stop.prevent="onClick"
  >
    <UseSvg v-if="icon" :icon="icon" class="tab-button__icon" />
    <slot />
  </button>
</template>

<style scoped lang="scss">
@import "frontend/init/jiffy/settings";
@import "frontend/init/jiffy/mixin";
@import "frontend/init/jiffy/button/mixin.scss";
@import "../../ArtworkQualityConfigPanel.scss";

.tab-button {
  $this: &;

  @include clear-button;

  flex: 1;
  border-radius: 8px 8px 0px 0px;
  background: $light-gray-blueish;
  padding: 10px 8px;
  color: $black-light;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &--active {
    background: $primary-light;
    color: $white;
    font-weight: 700;
    pointer-events: none;

    #{$this}__icon {
      color: $white;
    }
  }

  @include with-quality-container {
    padding: 10px 12px;
    font-size: 14px;
  }

  &__icon {
    width: 22px;
    height: 22px;
    color: $enhance-grey-modern-400;
    display: none;

    @include with-quality-container {
      display: inline-block;
    }
  }
}
</style>
